// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".nuxt-link-active[data-v-77ecc6fc] {\n  border-left-width: 1px;\n  border-top-width: 1px;\n  border-right-width: 1px;\n  border-top-left-radius: 0.25rem;\n  border-top-right-radius: 0.25rem;\n}\n.ui-font[data-v-77ecc6fc],\n.ui-font[data-v-77ecc6fc]:hover,\n.ui-font[data-v-77ecc6fc]:focus {\n  font-weight: var(--interfaceFontWeight, inherit);\n  color: var(--interfaceFontColor, inherit);\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
